import { GUEST_LISTS, type GuestListId } from '@/lib/bff/guests'

/** Plan-limited feature id for each guest list; Arrivals is never gated (VIS-535). */
export const GUEST_LIST_FEATURE: Record<GuestListId, string | null> = {
  arrivals: null,
  'failed-messages': 'failedMessages',
  'shadow-guests': 'shadowGuests',
}

export const GUEST_RECORD_FEATURES = {
  guestVisitHistory: 'guestVisitHistory',
  guestOrders: 'guestOrders',
  guestTables: 'guestTables',
} as const

export const ALL_GUEST_LICENCE_FEATURES = [
  GUEST_LIST_FEATURE['failed-messages'],
  GUEST_LIST_FEATURE['shadow-guests'],
  GUEST_RECORD_FEATURES.guestVisitHistory,
  GUEST_RECORD_FEATURES.guestOrders,
  GUEST_RECORD_FEATURES.guestTables,
].filter((id): id is string => id !== null)

export function offeredGuestLists(hasFeature: (featureId: string) => boolean): GuestListId[] {
  return GUEST_LISTS.filter((id) => {
    const feature = GUEST_LIST_FEATURE[id]
    return feature === null || hasFeature(feature)
  })
}

/** Remembered list when still offered; otherwise search-only (`null`). */
export function openingList(offered: GuestListId[], remembered: GuestListId | null): GuestListId | null {
  if (remembered !== null && offered.includes(remembered)) return remembered
  return null
}

export const isGuestListId = (value: string | null): value is GuestListId =>
  value !== null && (GUEST_LISTS as string[]).includes(value)
